const ChangePasswordInsideReducer = (state = null, action) => {
    switch (action.type) {
        case 'CHANGEPASSWORDINSIDE_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'CHANGEPASSWORDINSIDE_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default ChangePasswordInsideReducer;